import BaseController from "../../controller/BaseController";
import AdminDataService from "../../util/AdminDataService";
import JSONModel from "sap/ui/model/json/JSONModel";
import { Button$PressEvent } from "sap/m/Button";
import MessageBox from "sap/m/MessageBox";
import Validator from "../../util/Validator";
import ResourceBundle from "sap/base/i18n/ResourceBundle";

/**
 * @namespace com.reply.leaviosa.controller
 */
export default class PendingUsersController extends BaseController {
    private readonly USER_DIALOG_ID = "DialogCreateUpdatePendingUser";

    public async onInit(): Promise<void> {
        AdminDataService.getPendingUsers();
    }

    //*************************************************************************************
    // EVENT HANDLERS
    //*************************************************************************************

    public async onCreateUser(): Promise<void> {
        this.getView().setModel(new JSONModel({
            autoApprove: false,
        }), "user");
        await this.openDialog(this.USER_DIALOG_ID);
    }

    async onEdit(oEvent: Button$PressEvent): Promise<void> {

        const selectedUser = oEvent.getSource().getBindingContext("dataModel").getObject();

        this.getView().setModel(new JSONModel({
            ...selectedUser
        }), "user");

        await this.openDialog(this.USER_DIALOG_ID);
    }

    onTeamChange(oEvent: any): void {
        const value = oEvent.getParameter("value");
        if (value == null) {
            (this.getView().getModel("user") as JSONModel).setProperty("/teamId", null);
        }
    }

    async onSaveDialog(oEvent: Button$PressEvent): Promise<void> {

        const validator = new Validator();
        const valid = validator.validate(oEvent.getSource().getParent().getParent());
        if (!valid) return;

        const userData = (this.getView().getModel("user") as JSONModel).getData();

        if (userData.createdAt) {
            await AdminDataService.updatePendingUser(userData);
        } else {
            await AdminDataService.createPendingUser(userData);
        }

        AdminDataService.getPendingUsers();
        this.destroyDialog(this.USER_DIALOG_ID);
    }

    onCloseDialog(oEvent: Button$PressEvent): void {
        this.destroyDialog(this.USER_DIALOG_ID);
    }

    async onDeleteUser(oEvent: Button$PressEvent): Promise<void> {
        const deleteUserConfirmationText = (this.getResourceBundle() as ResourceBundle).getText("deleteUserConfirmation");
        const email = this.getView().getModel("user").getProperty("/email");
        MessageBox.confirm(deleteUserConfirmationText, {
            actions: [MessageBox.Action.OK, MessageBox.Action.CANCEL],
            emphasizedAction: MessageBox.Action.OK,
            onClose: (sAction: any) => {
                if (sAction === MessageBox.Action.OK) {
                    AdminDataService.deletePendingUser(email);
                    this.destroyDialog(this.USER_DIALOG_ID);
                }
            },
            dependentOn: this.getView()
        });
    }
}
